import React from 'react'
import "./why_us.css";
import useLanguage from '../customHook/useLanguage';
import { useTranslation } from 'react-i18next';

function Why_us() {
    const why_usData = [
        {
          english: {
            id: 1,
            image: "why_us_1.png",
            title: "International ISO 9001-2018 Nominated Organization, Banks Awarded 2018 2023.",
            description: "",
            dataDuration: "1000",
          },
          marathi: {
            id: 1,
            image: "why_us_1.png",
            title: "आंतरराष्ट्रीय आयएसओ 9001-2018 नामांकन प्राप्त संस्था, बँको पुरस्कार प्राप्त 2018 2023.",
            description: "",
            dataDuration: "1000",
          },
        },
        {
          english: {
            id: 2,
            image: "why_us_2.png",
            title: "Safe deposit locker facility at low rates.",
            description: "",
            dataDuration: "1000",
          },
          marathi: {
            id: 2,
            image: "why_us_2.png",
            title: "अल्प दरात सेफ डिपॉझिट लॉकर सुविधा.",
            description: "",
            dataDuration: "1000",
          },
        },
        {
          english: {
            id: 3,
            image: "why_us_3.2.png",
            title: "Out of 56 branches of Banyan Tree, 25 branches are in self-owned buildings with an extended area of ​​operation like Satara, Pune, Mumbai, Navi Mumbai, Thane, Raigad, Sangli, Ratnagiri, Kolhapur and Solapur districts.",
            description: "",
            dataDuration: "1500",
          },
          marathi: {
            id: 3,
            image: "why_us_3.2.png",
            title: "सातारा पुणे मुंबई नवी मुंबई ठाणे रायगड सांगली रत्नागिरी कोल्हापूर व सोलापूर जिल्हे एवढे विस्तारित कार्यक्षेत्र असलेल्या 56 शाखांचा वटवृक्ष पैकी 25 शाखा स्वमालकीच्या इमारतीमध्ये .",
            description: "",
            dataDuration: "1500",
          },
        },
        {
          english: {
            id: 4,
            image: "why_us_4.png",
            title: "100% Secured Deposits Secured Investments Secured Loans.",
            description: "We simplify interest rates and how they impact your finances...",
            dataDuration: "2000",
          },
          marathi: {
            id: 4,
            image: "why_us_4.png",
            title: "100% सुरक्षित ठेवी सुरक्षित गुंतवणूक सुरक्षित कर्ज.",
            description: "आम्ही व्याज दर आणि ते तुमच्या वित्तावर कसा प्रभाव टाकतात हे सोपे करतो...",
            dataDuration: "2000",
          },
        },
        {
          english: {
            id: 5,
            image: "why_us_5.2.png",
            title: "All branches computerized RTGS NEFT IMPS Mobile Banking facility available.",
            description: "",
            dataDuration: "1000",
          },
          marathi: {
            id: 5,
            image: "why_us_5.2.png",
            title: "सर्व शाखा संगणकीकृत आरटीजीएस एनईएफटी आय एम पी एस मोबाईल बँकिंग ची सुविधा उपलब्ध.",
            description: "",
            dataDuration: "1000",
          },
        },
        {
          english: {
            id: 6,
            image: "why_us_6.1.png",
            title: "The institute has its own mobile app available at your service 24/7",
            description: "",
            dataDuration: "1000",
          },
          marathi: {
            id: 6,
            image: "why_us_6.1.png",
            title: "संस्थेची स्वतःचे मोबाईल ॲप 24/7 आपल्या सेवेत उपलब्ध.",
            description: "",
            dataDuration: "1000",
          },
        },
        {
          english: {
            id: 7,
            image: "why_us_7.png",
            title: "Relief to depositors by merging 15 distressed credit institutions.",
            description: "",
            dataDuration: "1500",
          },
          marathi: {
            id: 7,
            image: "why_us_7.png",
            title: "अडचणीतील 15 पतसंस्था विलीनीकरण करून ठेवीदारांना दिलासा",
            description: "",
            dataDuration: "1500",
          },
        },
        {
          english: {
            id: 8,
            image: "why_us_8.png",
            title: "You will be amazed at the courteous and prompt service.",
            description: "",
            dataDuration: "2000",
          },
          marathi: {
            id: 8,
            image: "why_us_8.png",
            title: "तुम्ही चकित व्हाल इतकी विनम्र व तत्पर सेवा.",
            description: "",
            dataDuration: "2000",
          },
        },
        {
          english: {
            id: 9,
            image: "why_us_9.png",
            title: "Audit Class A tradition continued since the inception of the organization.",
            description: "",
            dataDuration: "2000",
          },
          marathi: {
            id: 9,
            image: "why_us_9.png",
            title: "संस्थेच्या स्थापनेपासून ऑडिट वर्ग अ परंपरा कायम.",
            description: "",
            dataDuration: "2000",
          },
        },
        {
          english: {
            id: 10,
            image: "why_us_10.png",
            title: "1255 Crore 33 Lakhs of the composite business of the organization.",
            description: "",
            dataDuration: "2000",
          },
          marathi: {
            id: 10,
            image: "why_us_10.png",
            title: "संस्थेचा संमिश्र व्यवसाय 1255 कोटी 33 लाख.",
            description: "",
            dataDuration: "2000",
          },
        },
        {
          english: {
            id: 11,
            image: "why_us_11.png",
            title: "A credit institution functions only in name but like a competent bank.",
            description: "",
            dataDuration: "2000",
          },
          marathi: {
            id: 11,
            image: "why_us_11.png",
            title: "पतसंस्थेचे फक्त नाव कामकाज मात्र सक्षम बँकेसारखे.",
            description: "",
            dataDuration: "2000",
          },
        },
        {
          english: {
            id: 12,
            image: "why_us_12.png",
            title: "The organization which provides atpar D.D facility at any place across all over the India.",
            description: "",
            dataDuration: "2000",
          },
          marathi: {
            id: 12,
            image: "why_us_12.png",
            title: "संस्था जी भारतभर कोणत्याही ठिकाणी अ‍ॅटपार डी.डी. सुविधा पुरवते.",
            description: "",
            dataDuration: "2000",
          },
        },
      ];
      const { t } = useTranslation();
      const languageState = useLanguage();
      
    return (
        <div className="container">
            <div className="text-center mb-3 my-lg-4">
                <h2 className="fw-normal d-inline-block position-relative custom-heading">
                   {t("why")} <span className="head-sub-text">{t("us")}</span>
                </h2>
            </div>
            <article className="why-us-card">
                <div className="why-us-card-list"
                >
                    {
                        why_usData?.map((data, index) => {
                            return (
                                <>
                                    <div className='why-us-border-card'
                                     data-aos="fade-right"
                                     data-aos-duration={1000}
                                     key={index}
                                    >
                                        <div className="why-us-card-image">
                                            <img
                                                src={data[languageState].image}
                                                alt={data[languageState].title}
                                            />
                                        </div>
                                        <div className="why-us-card-header">
                                            <p >{data[languageState].title}</p>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
            </article>
        </div>

    )
}

export default Why_us;